var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-form",
    {
      on: {
        submit: function submit($event) {
          $event.preventDefault()
          return _vm.addDomain($event)
        }
      }
    },
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            {
              staticClass: "pb-0",
              attrs: {
                cols: "12",
                md: "6",
                xl: "4"
              }
            },
            [
              _c("gg-text-field", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required|url",
                    expression: "'required|url'"
                  }
                ],
                attrs: {
                  label: "Domain",
                  name: "Domain",
                  "error-messages": _vm.errors.collect("Domain")
                },
                model: {
                  value: _vm.domain,
                  callback: function callback($$v) {
                    _vm.domain = $$v
                  },
                  expression: "domain"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            {
              staticClass: "pt-0",
              attrs: {
                cols: "12"
              }
            },
            [
              _c(
                "gg-btn",
                {
                  attrs: {
                    loading: _vm.loading
                  },
                  on: {
                    click: _vm.addDomain
                  }
                },
                [_vm._v(" Add Parked Domain ")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }